import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

export default function connectEnhancer(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
  options
) {
  return function(Component) {
    return withRouter(
      connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps,
        options
      )(Component)
    );
  };
}
